import ServiceFactory from '../services/service_factory';
import Device from "../utils/device/device";
import ExternalLinksController from '../components/external_links/external_links_component_controller';

class Debug {
	externalLinksPostMessageReceived(configKey, data) {
		let externalLinkController = ExternalLinksController.create(Object.assign({
			source: configKey
		}, {type: 'API'}));
		// externalLinkController._subscribePostMsg();
		externalLinkController._getHandlerByConfig().display();
		externalLinkController._postMessageHandler(data);
		// Event.fire(SYSTEM_EVENTS.POST_MESSAGE_ARRIVE, data);
	}

	showToastTest(param, skipConversion = false) {
		if (param.timeout) {
			param.timeout /= 1000;
		}
		if(!skipConversion) {
			param.cgt = JSON.stringify(param.cgt ? {'GameTypeID': param.cgt} : {});
            let convertedOptions = {
                MessageID: param.id,
				Title: param.title,
                SubTitle: param.message,
                DurationInSec: param.timeout,
                Icon: param.image,
                MetaDataParams: param.cgt
			};

			if (Device.isMobile()) {
				convertedOptions.MobileImage = param.image;
			}
			else {
				convertedOptions.PCImage = param.image;
			}
			ServiceFactory.create().toasterService().onToastMessageReceived([convertedOptions]);
		} else {
			ServiceFactory.create().toasterService().onToastMessageReceived(param);
		}
		return this;
	}
}

export default new Debug();